<template>
  <v-app>
    <v-navigation-drawer v-if="isBar" color="primary" :disable-resize-watcher="true" :disable-route-watcher="true" v-model="drawer" app clipped>
      <v-list v-if="siteConf.user">       
        <v-list-item v-if="lan=='fr'" link dark @click="setLan('en')">
          <v-list-item-icon>
            <v-icon dark>fa fa-globe</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>English</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item v-else link dark @click="setLan('fr')">
          <v-list-item-icon>
            <v-icon dark>fa fa-globe</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Français</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dark @click="$router.push('/' + siteID + '/user/contactme')">
          <v-list-item-icon>
            <v-icon dark>far fa-address-card</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("labels.ContactMe") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>       
      </v-list>
      <v-list v-else>
        <v-list-item v-if="lan=='fr'" link dark @click="setLan('en')">
          <v-list-item-icon>
            <v-icon dark>fa fa-globe</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>English</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item v-else link dark @click="setLan('fr')">
          <v-list-item-icon>
            <v-icon dark>fa fa-globe</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Français</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item link dark @click="$router.push('/' + siteID + '/user/contactme')">
          <v-list-item-icon>
            <v-icon dark>far fa-address-card</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("labels.ContactMe") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar v-if="isBar" app clipped-left color="primary" :dark="theme.dark">
      <v-toolbar-title>
        <v-avatar class="link">
          <span v-if="avatarText" class="headline" v-text="avatarText" />
          <img v-else :src="avatarImg" />
        </v-avatar>

        <div style="float: right;line-height:1em;" class="ml-3 mt-1 link">
          <div v-text="agentFullName" />
          <div class="caption">
            {{ agentTitle }}<span v-if="agentLic"> - {{ agentLic }}</span>
            <!-- <span v-if="agentLic">{{$t("labels.License#")}} {{ agentLic }}</span> -->
          </div>
        </div>
      </v-toolbar-title>

      <!-- <v-btn v-if="siteConf.user" @click="$router.push('/' + siteID + '/user/mydeals')" :dark="theme.dark" text class="ml-5 d-none d-sm-block">{{
        $t("labels.MyApplications")
      }}</v-btn> -->
      <v-spacer />

      
      <v-btn v-if="lan=='fr'" class="d-none d-sm-block" :dark="theme.dark" text @click="setLan('en')">English</v-btn>
      <v-btn v-else class="d-none d-sm-block" :dark="theme.dark" text @click="setLan('fr')">Français</v-btn>


      <v-btn  @click="$router.push('/' + siteID + '/user/contactme')" class="d-none d-sm-block" :dark="theme.dark" text>{{
        $t("labels.ContactMe")
      }}</v-btn> 

      <!-- <v-menu class="d-none d-sm-block" offset-y v-if="u">
        <template v-slot:activator="{ on }">
          <v-btn :dark="theme.dark" text v-on="on" class="d-none d-sm-block">
            {{ u.FirstName }} {{ u.LastName }}
            <v-icon class="ml-1" size="12">fas fa-angle-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link @click="logout">
            <v-list-item-title>{{ $t("labels.Logout") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>  -->

      <v-app-bar-nav-icon class="d-sm-none" dark @click="drawer = !drawer" />
    </v-app-bar>

    <v-content class="fill-height">
      <router-view />
    </v-content>

    <v-footer app class="footer text-center" :inset="true" v-if="isBar">
      <!-- <div style="font-size: 11px;">
        &copy; 2006-{{this.currentYear}}
        <a target="_blank" href="http://www.axiominnovations.com"> Axiom Innovations</a> Inc. All rights reserved.
      </div> -->
      <scarlettFooterVue :withSupportLink="false" />
      <v-spacer></v-spacer>
      <div style="font-size: 11px;">
        <a link color="primary" @click="privacyFlag = true" v-text="$t('labels.Privacy')"></a>
        <a link class="ml-5" color="Primary" @click="termFlag = true" v-text="$t('labels.Terms')"></a>
      </div>
    </v-footer>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>

    <v-dialog v-model="privacyFlag" fullscreen :scrollable="true">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t("labels.PrivacyPolicy") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="privacyFlag = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-6">
          <div style="color:black;" v-html="$t('messages.Privacy')"></div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="termFlag" fullscreen :scrollable="true">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t("labels.Terms") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="termFlag = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-6">
          <div style="color:black;" v-html="$t('messages.Term')"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import { EventBus } from "@/services/eventBus";
import uiSvc from "@/services/uiService";
import domainHelper from "@/services/domainHelper";
import scarlettFooterVue from '@/shared/components/scarlettFooter.vue';
export default {
   components:{
    scarlettFooterVue
  },
  data() {
    return {
      currentYear: null,
      privacyFlag: false,
      termFlag: false,
      drawer: false,
      loadFlag: false,
      siteID: this.$route.params.siteid,
      isBar: true,
      siteConf: {
        user: {},
        site: {}
      }
    };
  },
  methods: {
    setLan(lan){
      localStorageSvc.setLan(lan);
      window.location.reload();
    },
    setFavIcon(src) {
      let head = document.head || document.getElementsByTagName("head")[0];
      var link = document.createElement("link"),
        oldLink = document.getElementById("dynamic-favicon");
      link.id = "dynamic-favicon";
      link.rel = "shortcut icon";
      link.type="image/png";

      link.href =  domainHelper.getAPIHost() + '/ws/AgentFavIcon/' +  src;
      if (oldLink) {
        head.removeChild(oldLink);
      }
      head.appendChild(link);
    },
    logout() {
      localStorageSvc.removeUser();
      this.loadPage();
      this.$router.push("/" + this.siteID + '/home');
    },
    loadPage() {  
      const currentDate = new Date();
      this.currentYear = currentDate.getFullYear();     
      this.loadFlag = true;
      dataSvc.getSiteConf(this.siteID).then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {

            // if(!res.data.UserFlag){
            //   localStorageSvc.clear();
            //    let u = '/' + this.siteID + '/home';
            //    window.location=u;                
            //     return;
            // }

            this.siteConf.site = res.data.Link;
            this.siteConf.user = res.data.User;

            try{
              this.theme.dark = true;
              this.$vuetify.theme.themes.light.primary = this.siteConf.site.PrimaryColor;
            }catch(err){
              console.error(err);
            }

            try{
              if(res.data.Link.AgentProfile.FavIcon)
                this.setFavIcon(res.data.Link.AgentProfile.FavIcon);
            }catch(err){
              console.error(err);
            }
          } else {            

            this.$router.push("/" + this.siteID+'/home' ); 
          }
        })
        .catch(() => {
           dataSvc.getSiteConf(this.siteID).then(res => {
                 if (res.data.ReturnStatus.ReturnCode == 200) {
                    this.siteConf.site = res.data.Link;
                  this.siteConf.user = res.data.User;

                  try{
                    this.theme.dark = true;
                    this.$vuetify.theme.themes.light.primary = this.siteConf.site.PrimaryColor;
                  }catch(err){
                    console.error(err);
                  }

                  try{
                    if(res.data.Link.AgentProfile.FavIcon)
                      this.setFavIcon(res.data.Link.AgentProfile.FavIcon);
                  }catch(err){
                    console.error(err);
                  }
                 } else {
                    localStorageSvc.clear();
                    this.$router.push("/");
                 }
              }); 
        });
    }
  },
  computed: {
    lan(){
      return localStorageSvc.getLan();
    },
    u() {
      let rv = null;
      try {
        rv = this.siteConf.user;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    a() {
      let rv = null;
      try {
        rv = this.siteConf.site.AgentProfile;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentLic() {
      let rv = null;
      try {
        rv = this.a.AgentLic;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentTitle() {
      let rv = null;
      try {
        rv = this.a.Title;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentFullName() {
      let rv = null;
      try {
        rv = this.a.FirstName + " " + this.a.LastName;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    avatarText() {
      let rv = null;
      if (this.a) {
        if (!this.a.AgentPhoto) {
          rv = this.a.FirstName.charAt(0) + this.a.LastName.charAt(0);
        }
      }
      return rv;
    },
    avatarImg() {
      let rv = null;
      if (this.a && this.a.AgentPhoto) {
        rv = domainHelper.getAPIHost() + "/ws/AgentProfilePhoto/" + this.a.AgentPhoto;
      }
      return rv;
    }
  },
  created() {
    this.loadPage();
    EventBus.$on("usersignin", () => {
      this.loadPage();
    });
    EventBus.$on("showprivacy", () => {
      this.privacyFlag = true;
    });
    EventBus.$on("showterm", () => {
      this.termFlag = true;
    });
  },
  beforeDestroy() {
    EventBus.$off("usersignin");
    EventBus.$off("showprivacy");
    EventBus.$off("showterm");
  },
  mounted() {
    uiSvc.setTitle();

    let isFramed = false;
    try{
       isFramed =  window.self !== window.top;
    } catch(err) {
      isFramed = false;
    }
    this.isBar = !isFramed;
  },
  watch: {
    privacyFlag(n) {
      let ele = document.getElementsByTagName("html");
      if (n) {
        ele[0].style.overflow = "hidden";
      } else {
        ele[0].style.overflow = "";
      }
    },
    termFlag(n) {
      let ele = document.getElementsByTagName("html");
      if (n) {
        ele[0].style.overflow = "hidden";
      } else {
        ele[0].style.overflow = "";
      }
    }
  }
};
</script>

<style scoped>
.footer {
  border-top: 1px solid #404040;
}
</style>
